import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { debounce } from 'lodash-es';
import { useResponsive } from '~/client-flow/contexts/ResponsiveContext';
import { BrandSettingsBody } from '~/pages/BusinessDetails/BrandSettingsSection/BrandSettingsBody/BrandSettingsBody';
import { useBrandSettingsForm } from '~/pages/BusinessDetails/BrandSettingsSection/hooks/useBrandSettingsForm';
const AUTOSAVE_DELAY_MS = 1500;
export const InlineBrandSetup = (param)=>{
    let { testId, worksAt, autosaveDelayMs = AUTOSAVE_DELAY_MS } = param;
    var _logo_asDataURL;
    const { isMobile } = useResponsive();
    const { branding, setBranding, logo, setLogo, isDirty, isValid, errors, save } = useBrandSettingsForm({
        worksAt,
        silent: true
    });
    const debouncedSave = useMemo(()=>debounce(()=>save(), autosaveDelayMs), [
        save,
        autosaveDelayMs
    ]);
    useEffect(()=>{
        if (isDirty && isValid) {
            debouncedSave();
        }
        return ()=>debouncedSave.cancel();
    }, [
        isDirty,
        isValid,
        branding,
        logo,
        debouncedSave
    ]);
    const handleLogoChange = (data)=>{
        if (data) {
            setLogo({
                file: data.file,
                asDataURL: data.asDataURL
            });
        }
    };
    return /*#__PURE__*/ _jsx(BrandSettingsBody, {
        testId: testId,
        branding: branding,
        errors: errors,
        setBranding: setBranding,
        logoImage: (_logo_asDataURL = logo.asDataURL) !== null && _logo_asDataURL !== void 0 ? _logo_asDataURL : '',
        onLogoChange: handleLogoChange,
        saving: false,
        column: isMobile
    });
};
